type Dimensions = 'width' | 'height';

export const mediaMin = (pxVal: number, dimension: Dimensions = 'width') =>
  `only screen and (min-${dimension}: ${pxVal}px)`;

export const mediaMax = (pxVal: number, dimension: Dimensions = 'width') =>
  `only screen and (max-${dimension}: ${pxVal}px)`;

